<template>
  <div class="navigations" data-qa="drawer-div-3xi6vt">
    <v-navigation-drawer
      :right="$vuetify.rtl"
      class="appDrawer px-2"
      :mini-variant="mini"
      :expand-on-hover="false"
      :dark="$vuetify.dark"
      app
      v-model="drawer"
      hide-overlay
      width="305"
     data-qa="drawer-navigation-drawer-9xl43c">
      <v-layout justify-center class="header_logo" data-qa="drawer-layout-jlnpm7">
        <div pa-5 class="drawer-header-container" data-qa="drawer-div-s8wb02n">
            <div class="nav__header-logo" data-qa="drawer-div-269mvs"></div>
        </div>
      </v-layout>
      <v-list data-qa="drawer-list-44ehw">
        <div
          v-for="(item, indx) in navigationMenu"
          :key="item.title"
        >
          <v-list-item
            :color="primaryColor"
            class="v-list__tile--link theme--light"
            v-if="filterMenuItem(item)"
            link
            v-bind:to="item.path"
            :data-qa="`drawer-list-item-8gc4he-${indx}`">
            <!-- <v-icon :color="primaryColor" :class="newNavIcoList.includes(item.name) ? 'material-symbols-outlined icon' : 'icon'" :data-qa="`drawer-icon-ees57-${indx}`">{{ item.icon }}</v-icon> -->
            <dob-icon :iconKey="item.icon" />
            <v-flex class="pl-4" :data-qa="`drawer-flex-i7keg-${indx}`"></v-flex>
            <v-list-item-title class="mt-n1" :data-qa="`drawer-list-item-title-z10ku-${indx}`">
              <router-link
                :style="{ 'text-decoration': 'none' }"
                class="body-2 font-weight-light"
                v-bind:to="item.path"
                >{{ $t(`systemEnums.navigationMenu.${item.name}`) }}</router-link
                >
            </v-list-item-title>
          </v-list-item>
          <v-list-group
            no-action
            :color="primaryColor"
            v-if="showMenuItem(item)"
            :value="false"
            :data-qa="`drawer-list-group-frvpnj-${indx}`">
            <template v-slot:activator>
              <v-flex class="justify-center" :data-qa="`drawer-flex-isq578-${indx}`">
                <!-- <v-icon :color="primaryColor"
                  :class="newNavIcoList.includes(item.name) ? 'material-symbols-outlined icon' : 'icon'" :data-qa="`drawer-icon-kidv2c-${indx}`">
                  {{ item.icon }}
                </v-icon> -->
                <dob-icon :iconKey="item.icon" />
              </v-flex>
              <v-flex class="pl-4" :data-qa="`drawer-flex-ym964s-${indx}`"></v-flex>
              <v-list-item-title class="mt-n1" :data-qa="`drawer-list-item-title-6v7p13-${indx}`">
                <router-link
                  :style="{ 'text-decoration': 'none' }"
                  class="body-2 font-weight-light"
                  v-bind:to="item.path"
                >
                  {{ $t(`systemEnums.navigationMenu.${item.name}`) }}
                </router-link>
              </v-list-item-title>
            </template>
            <v-flex v-for="(view, i) in item.views" :key="i" :data-qa="`drawer-flex-ab5lh-${indx}-${i}`">
              <v-list-item
                v-if="!view.views"
                v-show="view.enable
                  ? view.title === menuLoanConfig.title
                    ? isLoanAccountsPresent(view.title)
                    : view.title === menuMortgageConfig.title
                      ? isMortgageAccountsPresent(view.title)
                      : true
                  : false"
                link
                v-bind:to="view.path"
                :color="primaryColor"
                id="list_item"
                :data-qa="`drawer-list-item-6gsumq-${indx}-${i}`">
                <div :style="{ padding :  navIcoExlList.includes(view.name) ? '0px 12px' : '0px'}" :data-qa="`drawer-div-skwfde-${indx}-${i}`">
                  <!-- <inline-svg
                  :src="getNavigationIcon(view.icon)"
                  :width="navIcoExlList.includes(view.name) ? '25' : '50'"
                  :height="navIcoExlList.includes(view.name) ? '25' : '50'"
                  aria-label="Navigation Icon"
                ></inline-svg> -->
                <dob-icon :iconKey="view.icon" />
                </div>
                <v-flex class="pl-4" :data-qa="`drawer-flex-68ec8g-${indx}-${i}`"></v-flex>
                <v-list-item-title class="mt-n1" id="list_item" :data-qa="`drawer-list-item-title-ws56ua-${indx}-${i}`">
                  <router-link
                    :style = "{ 'text-decoration': 'none', 'white-space': 'pre-wrap', color: onSurfaceMedium }"
                    class="body-2 font-weight-light"
                    v-bind:to="view.path"
                  >
                    {{ $t(`systemEnums.navigationMenu.${view.name}`) }}
                  </router-link>
                  <!-- TODO <router-link
                    style="text-decoration: none;  white-space: pre-wrap;"
                    class="body-2 font-weight-light"
                    v-bind:to="view.path"
                    >{{ getTitle(item.title,view.title)}}</router-link
                    > -->
                </v-list-item-title>
              </v-list-item>
              <v-list-group
                v-else
                no-action
                :value="false"
                :color="primaryColor"
                sub-group
                prepend-icon=""
                @click="paymentsIcon = !paymentsIcon"
                :data-qa="`drawer-list-group-y228av-${indx}-${i}`">
                <template v-slot:activator>
                  <v-flex class="justify-center" v-if="newNavIcoList.includes(view.name)" :data-qa="`drawer-flex-0wgy7j-${indx}-${i}`">
                    <!-- <v-icon color="black"
                    :class="newNavIcoList.includes(view.name) ? 'material-symbols-outlined' : 'icon'" :data-qa=" `drawer-icon-2w5bm5-${indx}-${i}`">
                      {{ view.icon }}
                    </v-icon> -->
                    <dob-icon :iconKey="view.icon" />
                  </v-flex>
                  <div :style="{ padding :  navIcoExlList.includes(view.name) ? '0px 12px' : '0px'}" v-if="!newNavIcoList.includes(view.name)" :data-qa="`drawer-div-q324il-${indx}-${i}`">
                    <!-- <inline-svg :src="getNavigationIcon(view.icon)"
                      :width="navIcoExlList.includes(view.name) ? '25' : '50'"
                      :height="navIcoExlList.includes(view.name) ? '25' : '50'"
                      aria-label="Navigation Icon">
                    </inline-svg> -->
                    <dob-icon :iconKey="view.icon" />
                  </div>
                  <v-list-item-title class="mt-n1 pl-4" id="list_item" :data-qa="`drawer-list-item-title-jdmpaq-${indx}-${i}`">
                    <router-link
                      :style="{ 'text-decoration': 'none' }"
                      class="body-2 font-weight-light"
                      v-bind:to="view.path">{{ $t(`systemEnums.navigationMenu.${view.name}`) }}
                    </router-link>
                  </v-list-item-title>
                  <v-icon :data-qa="`drawer-icon-mrq6pg-${indx}-${i}`">{{ paymentsIcon ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                </template>
                <v-flex v-for="(subSubItem, idx) in view.views" :key="idx" :data-qa="`drawer-flex-uytk1-${indx}-${i}-${idx}`">
                  <v-list-item
                    :color="primaryColor"
                    v-bind:to="subSubItem.path"
                    v-show="subSubItem.enable"
                    link
                    id="list_item"
                    :data-qa="`drawer-list-item-q9k0um8-${indx}-${i}-${idx}`">
                    <v-flex class="justify-center" v-if="newNavIcoList.includes(subSubItem.name)" :data-qa="`drawer-flex-9znf1t-${indx}-${i}-${idx}`">
                      <!-- <v-icon color="black" :class="newNavIcoList.includes(subSubItem.name) ? 'material-symbols-outlined' : 'icon'" :data-qa="`drawer-icon-a51ml-${indx}-${i}-${idx}`">
                        {{ subSubItem.icon }}
                      </v-icon> -->
                      <dob-icon :iconKey="subSubItem.icon" />
                    </v-flex>
                    <div class="ml-4" v-if="!newNavIcoList.includes(subSubItem.name)" :data-qa="`drawer-div-irb4i-${indx}-${i}-${idx}`">
                      <!-- <inline-svg :src="getNavigationIcon(subSubItem.icon)"
                        :width="navIcoExlList.includes(subSubItem.name) ? '25' : '50'"
                        :height="navIcoExlList.includes(subSubItem.name) ? '25' : '50'"
                        aria-label="Navigation Icon"
                      >
                      </inline-svg> -->
                      <dob-icon :iconKey="subSubItem.icon" />
                    </div>
                    <v-list-item-title class="text-left ml-4" id="list_item" :data-qa="`drawer-list-item-title-aoh6rf-${indx}-${i}-${idx}`">
                      <router-link
                        :style="{ 'text-decoration': 'none', 'white-space': 'pre-wrap', color: onSurfaceMedium }"
                        class="body-2 font-weight-light"
                        v-bind:to="{ path: subSubItem.path, name: subSubItem.name }">
                        {{ subSubItem.title }}
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                </v-flex>
              </v-list-group>
            </v-flex>
          </v-list-group>
        </div>
      </v-list>
      <template v-if="enableSupportMenus" v-slot:append>
        <v-list data-qa="drawer-list-0gkxxe">
          <v-list-item
            link
            target="_blank"
            class="v-list__tile--link theme--light"
           data-qa="drawer-list-item-6d0obr">
            <!-- <v-icon class="sub-icon" data-qa="drawer-icon-k6b808">mdi-chat-alert</v-icon> -->
            <dob-icon iconKey="drawer_about" />
            <v-flex class="pl-4" data-qa="drawer-flex-2y4ur6"></v-flex>
            <v-list-item-title @click="aboutModalConfig.enabled = true" class="sub-items body-2 font-weight-light" data-qa="drawer-list-item-title-dorbw5">{{ $t('common.about') }}</v-list-item-title>
          </v-list-item>

          <v-list-item
            link
            target="_blank"
            class="v-list__tile--link theme--light"
           data-qa="drawer-list-item-09uq8f">
            <!-- <v-icon class="sub-icon" data-qa="drawer-icon-ayzp19">mdi-face-agent</v-icon> -->
            <dob-icon iconKey="drawer_faq" />
            <v-flex class="pl-4" data-qa="drawer-flex-hfu7h"></v-flex>
            <v-list-item-title @click="faqModalConfig.enabled = true" class="sub-items body-2 font-weight-light" data-qa="drawer-list-item-title-jghz3">{{ $t('common.support') }}</v-list-item-title>
          </v-list-item>

          <v-list-item
            link
            :href="$appSettings.applicationSettings.helpUrl"
            target="_blank"
            class="v-list__tile--link theme--light"
           data-qa="drawer-list-item-e691hj">
            <!-- <v-icon class="sub-icon" data-qa="drawer-icon-apw1zo">mdi-help-circle</v-icon> -->
            <dob-icon iconKey="drawer_help" />
            <v-flex class="pl-4" data-qa="drawer-flex-jf2b9g"></v-flex>
            <v-list-item-title class="sub-items body-2 font-weight-light"  data-qa="drawer-list-item-title-ivxlc5">{{ $t('common.help') }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            class="v-list__tile--link theme--light"
           data-qa="drawer-list-item-56sbbo">
            <!-- <v-icon class="sub-icon" data-qa="drawer-icon-cvppzl">mdi-power-standby</v-icon> -->
            <dob-icon iconKey="drawer_logout" />
            <v-flex class="pl-4" data-qa="drawer-flex-2dl9gf"></v-flex>
            <v-list-item-title class="sub-items body-2 font-weight-light" @click="logoutConfirm" data-qa="drawer-list-item-title-nzw1b">{{ $t('common.logoutText') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <Modal :config="modalConfig" @btn1Action="logout" />
    <!-- FAQ Modal-->
    <Modal :config="faqModalConfig" @btn1Action="faqModalConfig.enabled = false">
      <span slot="modalContent" class="font-weight-bold" data-qa="drawer-span-xiksp">
        <DobFAQ />
      </span>
    </Modal>
    <!-- T&C -->
    <ConsentOverlay v-if="consentConfig.showConsent" :consentConfig="consentConfig"></ConsentOverlay>
    <Modal :config="aboutModalConfig" @btn1Action="aboutModalConfig.enabled = false">
      <span slot="modalContent" class="font-weight-bold" data-qa="drawer-span-8q3t7">
      <v-expansion-panels readonly data-qa="drawer-expansion-panels-bak8l7">
        <v-expansion-panel data-qa="drawer-expansion-panel-qd9jdj">
          <v-expansion-panel-header
            expand-icon=""
            class="expansionHeader text-subtitle-1 font-weight-medium"
           data-qa="drawer-expansion-panel-header-ghr0kh">
            <a
              v-if="enableTermsAndConditionsConsent"
              class="black--text"
              @click="displayConsentOverlayScreen"
             data-qa="drawer-a-3whspm">{{ $t("depositForm.termsAndConditionsLabel") }}</a>
            <a
              v-else
              class="black--text"
              :href="$appSettings.applicationSettings.termsAndConditions"
              target="_blank"
             data-qa="drawer-a-quyb225">{{ $t("depositForm.termsAndConditionsLabel") }}</a>
          </v-expansion-panel-header>
        </v-expansion-panel>
        <v-expansion-panel data-qa="drawer-expansion-panel-sygw3m">
          <v-expansion-panel-header
            expand-icon=""
            class="expansionHeader text-subtitle-1 font-weight-medium"
           data-qa="drawer-expansion-panel-header-i7a6t">
            <a
              class="black--text"
              :href="$appSettings.applicationSettings.privacyAndCookiePolicy"
              target="_blank"
             data-qa="drawer-a-ir0w7o">{{ $t("common.privacyAndCookiePolicy") }}</a>
          </v-expansion-panel-header>
        </v-expansion-panel>
      </v-expansion-panels>
      </span>
    </Modal>
  </div>
</template>
<script>
import '@/styles/common/appbar.scss'
import event from '@/util/event'
import store from '@/core/store'
import ConsentOverlay from '@/components/consentManagement/ConsentOverlay.vue'
import consentMixin from '@/core/mixins/getConsentData.js'
import preload from '@/util/preload'
import CommonService from '@/service/commonService.js'

export default {
  name: 'drawer',
  props: {
    expanded: {
      default: true,
      type: Boolean
    }
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    DobFAQ: () => import('@/views/common/DobFAQ.vue'),
    ConsentOverlay
  },
  mixins: [consentMixin],
  created () {
    const userStore = store.getters['userStore/userData']
    // Fetch Permissions for SME Users
    this.permissions = store.getters['profileStore/profileData']?.permissions
    // if accounts are available in store, then set values on create. Do not wait for emitted events.
    if (userStore && userStore.loanAccounts) {
      this.loanAccounts = userStore.loanAccounts
    }

    if (userStore && userStore.mortgageAccounts) {
      this.mortgageAccounts = userStore.mortgageAccounts
    }

    this.getAccounts()

    event.$on('set_myLoanAccounts', () => {
      if (this.enableLoanSection) {
        this.loanAccounts = userStore.loanAccounts
      }
    })

    // Set Mortgage Accounts
    event.$on('set_myMortgageAccounts', () => {
      if (this.enableMortgageSection) {
        this.mortgageAccounts = userStore.mortgageAccounts
      }
    })
    event.$on('APP_DRAWER_TOGGLED', () => {
      this.drawer = !this.drawer
    })
    event.$on('Close', () => {
      this.drawer = false
    })
    event.$on('set_myAccounts', () => {
      this.getAccounts()
    })
    this.isSmeLogin = JSON.parse(sessionStorage.getItem('isSmeLogin'))
    this.navigationMenu = JSON.parse(sessionStorage.getItem('navigationMenu'))
  },
  async mounted () {
    if (this.enableLocalPayments) {
      const paymentType = this.localPaymentsType
      const response = await CommonService.getPaymentMethods(paymentType)
      if (response && !response?.causes && response?.data?.status !== 500 && !response?.data?.name === 'Error') {
        this.paymentMethods = response?.filter(r => r.direction === 'O')
        this.paymentMethods = await Promise.all(this.paymentMethods.map(async method => {
          const details = await CommonService.getPaymentTemplateDetails(paymentType, method.paymentTemplateId)
          return {
            ...method,
            details
          }
        }))

        if (this.paymentMethods && this.paymentMethods.length === 1) {
          this.paymentMethods.forEach(item => {
            this.$router.addRoute({
              path: '/localPayments',
              name: 'LocalPayments',
              component: () =>
                import('@/views/payments/InterBankPayments/LocalPayments/LocalPayments.vue'),
              meta: {
                requiresAuth: true,
                breadcrumb: {
                  breadcrumb: '',
                  icon: 'mdi-home',
                  title: 'Domestic Payments',
                  subTitle: `${item.paymentMethod}`
                },
                OTP: {
                  validateOTPInternally: true,
                  OTPConfig: 'defaultConfigurations.localPayments.enableOTP',
                  routesToValidate: ['api/proxy/fepymt/creditTransferInitiate']
                },
                paymentMethod: item
              }
            })
          })
        } else {
          this.navigationMenu.forEach(menuItem => {
            if (menuItem.name === 'Payments') {
              menuItem.views.forEach(view => {
                if (view.name === 'LocalPayments') {
                  view.path = ''
                }
              })
            }
          })

          // Add new routes similar to routes in index.js
          this.paymentMethods.forEach(item => {
            this.subMenu.push({
              icon: 'drawer_payments_localPayments',
              title: `${item.paymentMethod}`,
              path: `/${item.paymentMethod}`,
              name: `${item.paymentMethod}`,
              enable: true
            })

            this.$router.addRoute({
              path: `/${item.paymentMethod}`,
              name: `${item.paymentMethod}`,
              component: () =>
                import('@/views/payments/InterBankPayments/LocalPayments/LocalPayments.vue'),
              meta: {
                requiresAuth: true,
                breadcrumb: {
                  breadcrumb: '',
                  icon: 'mdi-home',
                  title: 'Domestic Payments',
                  subTitle: `${item.paymentMethod}`
                },
                OTP: {
                  validateOTPInternally: true,
                  OTPConfig: 'defaultConfigurations.localPayments.enableOTP',
                  routesToValidate: ['api/proxy/fepymt/creditTransferInitiate']
                },
                paymentMethod: item
              }
            })
          })

          // add subMenu items based on paymentMethods available
          this.navigationMenu.forEach(menu => {
            if (menu.name === 'Payments') {
              menu.views.forEach(subMenu => {
                if (subMenu.name === 'LocalPayments') {
                  subMenu.views = this.subMenu
                }
              })
            }
          })
        }
      } else {
        this.$router.addRoute({
          path: '/localPayments',
          name: 'LocalPayments',
          component: () =>
            import('@/views/payments/InterBankPayments/LocalPayments/LocalPayments.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: {
              breadcrumb: '',
              icon: 'mdi-home',
              title: 'Domestic Payments',
              subTitle: 'Domestic Payments'
            },
            paymentMethod: '',
            paymentError: response.causes || response.data
          }
        })
      }
    }

    if (this.navigationMenu) {
      // Accounts Menu
      for (const item of this.navigationMenu[1].views) {
        if (item.name === 'Loan') {
          this.menuLoanConfig = item
        }
        if (item.name === 'MortgageAgreementList') {
          this.menuMortgageConfig = item
        }
        if (item.icon === 'drawer_accounts_savings') {
          if (this.enableUkMarketSavingAccInDashboard) {
            // UKMarket Savings
            this.navigationMenu[1].views.forEach((view, index) => {
              // Savings, Deposits - Set to false
              if (view.title === 'Savings Account' || view.title === 'Deposit Account') {
                this.navigationMenu[1].views[index].enable = false
              }
              // Regular Savings, Cash ISA, Fixed Rate Deposits - Set to true
              const labels = this.ukMarketSavingsGrouping.map(group => this.$t(group.label))
              if (labels.includes(view.title)) {
                this.navigationMenu[1].views[index].enable = true
                switch (this.navigationMenu[1].views[index].title) {
                  case 'Savings Account':
                    this.navigationMenu[1].views[index].name = 'Savings'
                    break
                  case 'Current Account':
                    this.navigationMenu[1].views[index].name = 'Current'
                    break
                  case 'Deposit Account':
                    this.navigationMenu[1].views[index].name = 'Deposit'
                    break
                }
              }
            })
          } else {
            // Non-UKMarket Savings
            this.navigationMenu[1].views.forEach((view, index) => {
              switch (this.navigationMenu[1].views[index].title) {
                case 'Savings Account':
                  this.navigationMenu[1].views[index].name = 'SavingsAccount'
                  break
                case 'Current Account':
                  this.navigationMenu[1].views[index].name = 'CurrentAccount'
                  break
                case 'Deposit Account':
                  this.navigationMenu[1].views[index].name = 'DepositsAccount'
                  break
              }
              // Regular Savings, Cash ISA, Fixed Rate Deposits - Set to false
              const labels = this.ukMarketSavingsGrouping.map(group => this.$t(group.label))
              if (labels.includes(view.title)) {
                this.navigationMenu[1].views[index].enable = false
              }
            })
          }
          this.menuSavingsConfig = item
        }
      }
      // Cards Menu
      this.navigationMenu.forEach((item, index) => {
        if (item.name === 'Cards') {
          if ((this.isSmeLogin && this.enableRoleBasedAccess)
            ? (!this.permissions?.includes('VIEW_CREDIT_CARDS') && !this.permissions?.includes('VIEW_DEBIT_CARDS'))
            : !this.enableCardsSection
          ) {
            this.navigationMenu[index].enable = false
          }
        }
      })
      if (!this.enableRecurringPaymentsOption || this.nominatedAccountsConfig.enableNominatedAccountFeatures) {
        for (const item of this.navigationMenu) {
          if (item.name === 'Payments') {
            for (const i of item.views) {
              if (i.name === 'Payee' && this.nominatedAccountsConfig.enableNominatedAccountFeatures) {
                i.name = 'PayeeForNominated'
              }
              if (i.name === 'RecurringAndFuturePayments' && !this.enableRecurringPaymentsOption) {
                i.name = 'ManageFuturePayments'
              }
            }
          }
        }
      }
      // TODO: Hide Main menu when submenu's are hidden/disabled
    }
  },
  updated () {
    // Set Mortgage Accounts
    if (this.ifMortgageAccountsAvailable()) {
      this.mortgageAccounts = store.getters['userStore/userData'].mortgageAccounts
    }
  },
  data () {
    return {
      subMenu: [],
      paymentsIcon: true,
      paymentMethods: [],
      navigationMenu: '',
      navIcoExlList: ['ConsolidatedStatement', 'AccountStatements', 'BillPaymentsHistory', 'RecurringAndFuturePayments', 'ManageFuturePayments'],
      newNavIcoList: ['Admin', 'Roles', 'AssignRoles'],
      customColor: '',
      drawer: true,
      mini: false,
      isNoticeAccounts: false,
      right: null,
      modalConfig: {
        enabled: false,
        persistent: true,
        subtitle: this.$t('common.confirmation_message'),
        btn2Label: this.$t('common.no'),
        btn1Label: this.$t('common.yes'),
        outlinedSaveBtn: true,
        outlinedCancelBtn: false,
        width: 400,
        placeholder: 'common.logoutText'
      },
      faqModalConfig: {
        cancelButton: '',
        outlinedSaveBtn: false,
        outlinedCancelBtn: true,
        enabled: false,
        persistent: true,
        btn1Label: this.$t('common.okay'),
        width: 700,
        placeholder: 'login.faq.faqTitle'
      },
      aboutModalConfig: {
        btn1Label: 'OK',
        outlinedSaveBtn: false,
        outlinedCancelBtn: true,
        enabled: false,
        persistent: true,
        btn2Label: '',
        width: 700,
        placeholder: 'common.about'
      },
      loanAccounts: [],
      mortgageAccounts: [],
      menuLoanConfig: {},
      menuMortgageConfig: {},
      menuSavingsConfig: {},
      nominatedAccountsConfig: this.$appSettings.defaultConfigurations.nominatedAccounts,
      enableSupportMenus: this.$appSettings.defaultConfigurations.landingPageConfig.enableSupportMenus,
      enableMortgageSection: this.$appSettings.defaultConfigurations.landingPageConfig.enableMortgageSection,
      enableLocalPayments: this.$appSettings.defaultConfigurations.landingPageConfig.enableLocalPaymentSection,
      enableRoleSection: this.$appSettings.defaultConfigurations.landingPageConfig.enableRolesSection,
      localPaymentsType: this.$appSettings.defaultConfigurations.localPayments.paymentType,
      enableCardsSection: this.$appSettings.defaultConfigurations.cards.enableCreditCard || this.$appSettings.defaultConfigurations.cards.enableDebitCard,
      enableLoanSection: this.$appSettings.defaultConfigurations.landingPageConfig.enableLoanSection,
      enableRecurringPaymentsOption: this.$appSettings.defaultConfigurations.payments.enableRecurringPaymentsOption,
      enableUkMarketSavingAccInDashboard:
        this.$appSettings.defaultConfigurations.landingPageConfig
          .enableUkMarketSavingAccInDashboard,
      ukMarketSavingsGrouping:
        this.$appSettings.defaultConfigurations.landingPageConfig
          .ukMarketSavingsGrouping,
      isSmeLogin: false,
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      consentConfig: {
        showConsent: false
      },
      enableTermsAndConditionsConsent: this.$appSettings.defaultConfigurations.consentManagement.enableConsent,
      customerCode: JSON.parse(sessionStorage.getItem('customerCode')),
      feusId: JSON.parse(sessionStorage.getItem('username')),
      permissions: []
    }
  },
  methods: {
    displayConsentOverlayScreen () {
      const userStore = store.getters['userStore/userData']
      if (userStore && userStore.consentConfig) {
        this.consentConfig = userStore.consentConfig
        this.consentConfig.showConsent = true
      } else this.loadConsentData()
    },
    async loadConsentData () {
      this.feusId
        ? await preload.getCustomerDetails((this.isSmeLogin && this.enableTermsAndConditionsConsent)
          ? this.feusId
          : this.isSmeLogin ? this.customerCode : this.feusId)
        : await preload.getCustomerDetails(this.email)
      // Check T&C
      this.getConsentData(this.feusId, true)
    },
    getTitle (title, view) {
      // TODO if (this.isNoticeAccounts && title === 'Accounts') {
      //   return view === this.menuSavingsConfig.title ? this.$t('common.savingsNoticeLabel') : view
      // }
      return view
    },
    ifMortgageAccountsAvailable () {
      return store.getters['userStore/userData'].mortgageAccounts
    },
    isLoanAccountsPresent (accountsType) {
      if (this.enableLoanSection && (accountsType === this.menuLoanConfig.title)) {
        return this.loanAccounts && this.loanAccounts.length
      }
      return false
    },
    isMortgageAccountsPresent (accountsType) {
      if (this.enableMortgageSection && (accountsType === this.menuMortgageConfig.title)) {
        return this.mortgageAccounts && this.mortgageAccounts.length
      }
      return false
    },
    async getAccounts () {
      // Notice AC List
      const myAccounts = await store.getters['userStore/userData'].myAccounts
      if (myAccounts) {
        if (myAccounts.noticeAccounts && myAccounts.noticeAccounts.accountList.length) {
          this.isNoticeAccounts = true
        }
      }
    },
    getNavigationIcon (icon) {
      return this.getSvgIconSrc(icon)
    },
    logout () {
      this.$logoutSetting.methods.systemLogout()
      // this.$router.push('/login')
    },
    logoutConfirm () {
      this.modalConfig.enabled = true
    },
    closeMenu () {
      this.drawer = false
    },
    filterMenuItem (item) {
      // Disabled Mandates for non-SME users

      // TODO: Apply checking for SME Admin identifier once available
      if (item.enable && !item.views) {
        if (!this.isSmeLogin && (item.title === 'Mandates' || item.title === 'Roles')) {
          return false
        }
        if (this.isSmeLogin && item.enable && !item.views && item.title === 'Mandates') {
          if (this.enableRoleBasedAccess
            ? !this.permissions?.includes('MANDATE_DEFINITION_AND_MAINTENANCE')
            : false) {
            return false // Removes 'Account Mandate' from Menu
          }
        }
        return item
      }
    },
    showMenuItem ({ title, enable, views }) {
      // To disable menu items for SME Users
      if (this.isSmeLogin) {
        if (title === 'Payments') {
          const excludeMenuList = ['BillPaymentsHistory']
          if (!this.enableLocalPayments ? true : (this.enableRoleBasedAccess ? !this.permissions?.includes('LOCAL_PAYMENTS') : false)) {
            excludeMenuList.push('LocalPayments')
          }
          if (this.enableRoleBasedAccess ? !this.permissions?.includes('VIEW_BILL_PAYMENTS') : true) {
            excludeMenuList.push('BillPaymentsHistory')
          }
          if (this.enableRoleBasedAccess && !this.permissions?.includes('VIEW_STANDING_ORDER')) {
            excludeMenuList.push('RecurringAndFuturePayments')
          }
          if (this.enableRoleBasedAccess && !this.permissions?.includes('TRANSFER_FUNDS')) {
            excludeMenuList.push('TransferFunds')
          }
          if (this.enableRoleBasedAccess && !this.permissions?.includes('UKFPS')) {
            excludeMenuList.push('DomesticPayments')
          }
          if (this.enableRoleBasedAccess && !this.permissions?.includes('SEPA')) {
            excludeMenuList.push('InternationalPayments')
          }
          if (this.enableRoleBasedAccess && !this.permissions?.includes('VIEW_PAYEES')) {
            excludeMenuList.push('DomesticPayments')
            excludeMenuList.push('InternationalPayments')
            excludeMenuList.push('Payee')
          }
          if (this.enableRoleBasedAccess && !this.permissions?.includes('SWIFT')) {
            excludeMenuList.push('SwiftPayments')
          }
          views.forEach((subPayments, index) => {
            if (excludeMenuList.includes(subPayments.name)) {
              // views[index].enable = false
              views.splice(index, 1)
            }
          })
        }
        if (title === 'Statements') {
          const excludeMenuList = []
          if (this.enableRoleBasedAccess && !this.permissions?.includes('CONSOLIDATED_STATEMENTS')) {
            excludeMenuList.push('ConsolidatedStatement')
          }
          if (
            this.enableRoleBasedAccess &&
            (!(this.permissions?.includes('CURRENT_VIEW_DETAILS') && this.permissions?.includes('CURRENT_VIEW_AND_DOWNLOAD_STATEMENTS')) &&
            !(this.permissions?.includes('SAVING_VIEW_DETAILS') && this.permissions?.includes('SAVING_VIEW_AND_DOWNLOAD_STATEMENTS')) &&
            !(this.permissions?.includes('LOAN_VIEW_DETAILS') && this.permissions?.includes('LOAN_VIEW_AND_DOWNLOAD_STATEMENTS')) &&
            !this.permissions?.includes('DEPOSITS_VIEW_DETAILS'))
          ) {
            excludeMenuList.push('AccountStatements')
          }
          views.forEach((subMenu, index) => {
            if (excludeMenuList.includes(subMenu.name)) {
              views.splice(index, 1)
            }
          })
        }
        if (title === 'Cards' && this.enableRoleBasedAccess) {
          const excludeMenuList = []
          if (!this.permissions?.includes('VIEW_CREDIT_CARDS')) {
            excludeMenuList.push('CreditCard')
          }
          if (!this.permissions?.includes('VIEW_DEBIT_CARDS')) {
            excludeMenuList.push('DebitCard')
          }
          views.forEach((subMenu, index) => {
            if (excludeMenuList.includes(subMenu.name)) {
              // views[index].enable = false
              views.splice(index, 1)
            }
          })
        }
        if (title === 'Accounts') {
          const excludeMenuList = []
          const checkAccountsMenuPermissions = [
            {
              permission: 'LOAN_VIEW_DETAILS',
              menu: 'Loan'
            },
            {
              permission: 'LOAN_VIEW_DETAILS',
              menu: 'MortgageAgreementList'
            },
            {
              permission: 'CURRENT_VIEW_DETAILS',
              menu: 'CurrentAccount'
            },
            {
              permission: 'DEPOSITS_VIEW_DETAILS',
              menu: 'DepositsAccount'
            }
          ]
          checkAccountsMenuPermissions.forEach(item => {
            if (this.enableRoleBasedAccess && !this.permissions?.includes(item.permission)) {
              excludeMenuList.push(item.menu)
            }
          })
          // Savings account menu - covers 'SAVING_VIEW_DETAILS' & 'NOTICE_VIEW_DETAILS' permissions
          if (this.enableRoleBasedAccess && (!this.permissions?.includes('SAVING_VIEW_DETAILS') && !this.permissions?.includes('NOTICE_VIEW_DETAILS'))) {
            excludeMenuList.push('Savings')
          }

          views.forEach((subMenu, index) => {
            if (excludeMenuList.includes(subMenu.name)) {
              // views[index].enable = false
              views.splice(index, 1)
            }
          })
        }
        if (title === 'Admin') {
          if (!this.enableRoleSection || (this.enableRoleBasedAccess && !this.permissions?.includes('VIEW_ROLES'))) {
            return false
          }
        }
      }

      // To disable sub menu items for Non-SME Users
      if (!this.isSmeLogin && title === 'Payments') {
        const excludeMenuList = []
        if (!this.enableLocalPayments) {
          excludeMenuList.push('LocalPayments')
        }
        views.forEach((subPayments, index) => {
          if (excludeMenuList.includes(subPayments.name)) {
            // views[index].enable = false
            views.splice(index, 1)
          }
        })
      }
      if (!this.isSmeLogin && title === 'Admin') {
        return false
      }
      return views && enable
    }
  },
  watch: {
    drawer () {
      event.$emit('drawerEvent', this.drawer)
      event.$emit('Hide_header_logo', this.drawer)
    }
  }
}
</script>

<style lang="scss" scoped>
.navigations {
  & a {
    text-decoration: none;
    color: #414141;
  }
}
.v-list-group__items .v-list-item, .v-list-group__items .v-list-group__items {
    overflow: hidden;
    border-left: 1px solid rgba(105, 78, 214, 0.3);
    padding-left: 31px ;
}

.v-list .v-list-item--active {
    color: inherit;
    border-left: 6px solid;
    .router-link-exact-active {
      color: $primary !important;
      font-size: 14px !important;
      font-style: normal;
      font-weight: 500 !important;
      line-height: 21px; /* 150% */
      letter-spacing: 0.1px !important;
}
}

.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 0;
}

.v-list-item--active::before {
  border-radius: 0px 8px 8px 0px;
  opacity: 0.12 !important;
}

.icon {
  background-color: $greyColor;
  padding: 4px;
  border-radius: 100%;
}

.sub-items {
  color: $primary;
}

.sub-icon {
  background-color: $greyColor; //rgba(0, 0, 0, 0.04);
  padding: 4px;
  border-radius: 100%;
  color: $primary;
}

.header_logo {
    margin-top: 7px;
    margin-bottom: 7px;
  }

@media only screen and (max-width: 960px) {
   .header_logo {
    margin-top: 0px;
    margin-bottom: 6px;
  }
}
</style>
